var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4998 16.5H14.1148L19.0648 11.565C19.3473 11.2826 19.506 10.8995 19.506 10.5C19.506 10.1006 19.3473 9.71749 19.0648 9.43503C18.7824 9.15258 18.3993 8.9939 17.9998 8.9939C17.6004 8.9939 17.2173 9.15258 16.9348 9.43503L9.43484 16.935C9.29828 17.0777 9.19124 17.2459 9.11984 17.43C8.96982 17.7952 8.96982 18.2048 9.11984 18.57C9.19124 18.7542 9.29828 18.9224 9.43484 19.065L16.9348 26.565C17.0743 26.7056 17.2402 26.8172 17.423 26.8934C17.6058 26.9695 17.8018 27.0087 17.9998 27.0087C18.1979 27.0087 18.3939 26.9695 18.5767 26.8934C18.7595 26.8172 18.9254 26.7056 19.0648 26.565C19.2054 26.4256 19.317 26.2597 19.3932 26.0769C19.4693 25.8941 19.5085 25.6981 19.5085 25.5C19.5085 25.302 19.4693 25.106 19.3932 24.9232C19.317 24.7404 19.2054 24.5745 19.0648 24.435L14.1148 19.5H25.4998C25.8977 19.5 26.2792 19.342 26.5605 19.0607C26.8418 18.7794 26.9998 18.3979 26.9998 18C26.9998 17.6022 26.8418 17.2207 26.5605 16.9394C26.2792 16.6581 25.8977 16.5 25.4998 16.5Z",
    fill: "#0A83FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.87709093ff0e735087618ca275e84e5f.svg";
export { ForwardRef as ReactComponent };